module.exports = __webpack_public_path__ + "static/media/golem.26fb2ba8.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/coins/golem.svg
// module id = 1143
// module chunks = 0